import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from '@heroicons/react/24/outline';
import AnimatedBackground from './AnimatedBackground';
import BackgroundGraph from './BackgroundGraph';

const Hero = () => {
  return (
    <div id="home" className="relative bg-gradient-to-br from-dark-900 via-dark-800 to-dark-950 overflow-hidden">
      <AnimatedBackground />
      <BackgroundGraph />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
        <div className="text-center relative z-10">
          <motion.div
            className="flex justify-center mb-8"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
          >
            <img 
              src="/logo.png" 
              alt="SpeedR AI Logo" 
              className="h-24 w-auto md:h-32"
            />
          </motion.div>
          <motion.h1 
            className="text-4xl font-bold tracking-tight text-white sm:text-6xl"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            AI That Works
            <motion.span 
              className="block text-primary-400"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
            >
              Offline
            </motion.span>
          </motion.h1>
          <motion.p 
            className="mx-auto mt-6 max-w-2xl text-lg leading-8 text-primary-200"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Experience the power of artificial intelligence without internet dependency. 
            Speedr brings you cutting-edge AI models that run entirely on your device.
          </motion.p>
          <motion.div 
            className="mt-10 flex items-center justify-center gap-x-6"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <motion.a
              href="#ai-app"
              className="rounded-md bg-primary-500 px-6 py-3 text-base font-semibold text-dark-900 shadow-sm hover:bg-primary-400 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Try AI App
            </motion.a>
            <motion.a
              href="#ai-doctor"
              className="rounded-md px-6 py-3 text-base font-semibold text-white border border-primary-500/30 hover:bg-primary-500/10 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500"
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Meet AI Doctor
            </motion.a>
          </motion.div>
        </div>
      </div>
      <motion.div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10"
        animate={{ y: [0, 10, 0] }}
        transition={{ duration: 2, repeat: Infinity }}
      >
        <ArrowDownIcon className="h-6 w-6 text-primary-400/50" />
      </motion.div>
    </div>
  );
};

export default Hero;
